<template>
  <PreloaderComponent />
  <InvitationImageComponent />
  <EventTimelineComponent />
  <AccessComponent />
  <ConceptComponent />
  <RsvpFormComponent />



  <div class="petal-container">
    <div v-for="petal in petals" :key="petal.id" class="petal" :style="{
      left: petal.left,
      animationDuration: petal.duration,
      opacity: petal.opacity,
      top: '-30px'
    }" v-html="petal.svg" @animationend="removePetal(petal.id)"></div>
  </div>
</template>

<script>
import PreloaderComponent from '@/components/preloader/PreloaderComponent.vue';
// import NavigationComponent from '@/components/navigations/NavigationComponent.vue';
import InvitationImageComponent from '@/components/invitation-image/InvitationImageComponent.vue';
import EventTimelineComponent from '@/components/event-timeline/EventTimelineComponent.vue';
import AccessComponent from '@/components/access/AccessComponent.vue';
import ConceptComponent from '@/components/concept/ConceptComponent.vue';
import RsvpFormComponent from '@/components/rsvp_form/RsvpFormComponent.vue';

const petal1 = `
  <svg width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="petalGradient" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" style="stop-color:rgb(255,100,100);stop-opacity:1" />
      <stop offset="50%" style="stop-color:rgb(200,50,50);stop-opacity:1" />
      <stop offset="100%" style="stop-color:rgb(150,0,0);stop-opacity:1" />
    </linearGradient>
  </defs>
  <path d="M 100 20 C 120 0, 180 30, 150 100 C 140 160, 100 190, 80 180 C 60 170, 20 130, 50 70 C 60 40, 80 10, 100 20 Z"
        fill="url(#petalGradient)"
        stroke="none" />
</svg>
`

const petal2 = `
  <svg width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="petalGradient2" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" style="stop-color:rgb(255,150,150);stop-opacity:1" />
      <stop offset="50%" style="stop-color:rgb(220,80,80);stop-opacity:1" />
      <stop offset="100%" style="stop-color:rgb(180,20,20);stop-opacity:1" />
    </linearGradient>
  </defs>
  <path d="M 100 30 C 130 10, 170 40, 160 90 C 150 140, 110 180, 90 170 C 70 160, 30 120, 40 70 C 50 40, 70 20, 100 30 Z"
        fill="url(#petalGradient2)"
        stroke="none" />
</svg>
`

const petal3 = `
  <svg width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="petalGradient3" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" style="stop-color:rgb(255,120,120);stop-opacity:1" />
      <stop offset="50%" style="stop-color:rgb(210,60,60);stop-opacity:1" />
      <stop offset="100%" style="stop-color:rgb(160,0,0);stop-opacity:1" />
    </linearGradient>
  </defs>
  <path d="M 100 40 C 140 20, 180 50, 170 100 C 160 150, 120 190, 100 180 C 80 170, 40 130, 50 80 C 60 50, 80 30, 100 40 Z"
        fill="url(#petalGradient3)"
        stroke="none" />
</svg>
`

const petal4 = `
  <svg width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="petalGradient4" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" style="stop-color:rgb(255,130,130);stop-opacity:1" />
      <stop offset="50%" style="stop-color:rgb(200,70,70);stop-opacity:1" />
      <stop offset="100%" style="stop-color:rgb(150,10,10);stop-opacity:1" />
    </linearGradient>
  </defs>
  <path d="M 100 50 C 150 30, 190 60, 180 110 C 170 160, 130 200, 110 190 C 90 180, 50 140, 60 90 C 70 60, 90 40, 100 50 Z"
        fill="url(#petalGradient4)"
        stroke="none" />
</svg>
`

const petal5 = `
  <svg width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="petalGradient5" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" style="stop-color:rgb(255,140,140);stop-opacity:1" />
      <stop offset="50%" style="stop-color:rgb(190,80,80);stop-opacity:1" />
      <stop offset="100%" style="stop-color:rgb(140,20,20);stop-opacity:1" />
    </linearGradient>
  </defs>
  <path d="M 100 60 C 160 40, 200 70, 190 120 C 180 170, 140 210, 120 200 C 100 190, 60 150, 70 100 C 80 70, 100 50, 100 60 Z"
        fill="url(#petalGradient5)"
        stroke="none" />
</svg>
`

const petalSvgs = [petal1, petal2, petal3, petal4, petal5];

export default {
  name: 'HomePage',
  components: {
    PreloaderComponent,
    // NavigationComponent,
    InvitationImageComponent,
    EventTimelineComponent,
    AccessComponent,
    ConceptComponent,
    RsvpFormComponent,
  },
  data() {
    return {
      petals: [],
      intervalId: null,
    };
  },
  methods: {
    createPetal() {
      const svg = petalSvgs[Math.floor(Math.random() * 10) % 5]
      const id = Date.now() + Math.random();
      const duration = (Math.random() * 5 + 10);
      this.petals.push({
        id,
        left: Math.random() * 100 + 'vw',
        duration: duration + 's',
        opacity: Math.random().toFixed(2),
        svg
      });
    },
    removePetal(id) {
      this.petals = this.petals.filter(p => p.id !== id);
    }
  },
  mounted() {
    this.intervalId = setInterval(this.createPetal, 800);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  }
}
</script>

<style scoped>
.petal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}

.petal {
  position: absolute;
  width: 30px;
  height: 30px;
  animation: fall linear forwards;
}

@keyframes fall {
  0% {
    transform: translateY(0) rotate(0deg);
  }

  100% {
    transform: translateY(110vh) rotate(360deg);
    /* opacity: 0; */
  }
}
</style>
